import cbSelectedTemplateReducer from '@app/redux/cbSelectedTemplateSlice';
import { configureStore } from '@reduxjs/toolkit';
import interstitialFormDataReducer from './features/interstitialFormDataSlice';
import interstitialReducer from './features/interstitialSlice';
import mcValidationReducer from './features/mcValidationSlice';
import nativePushFormDataReducer from './features/nativePushFormDataSlice';
import nativePushReducer from './features/nativePushSlice';
import realParamsReducer from './features/realParamsSlice';
import smsReducer from './features/smsSlice';
import templateModalReducer from './features/templateModalSlice';
import templatesReducer from './features/templatesSlice';

export const store = configureStore({
  reducer: {
    templateModal: templateModalReducer,
    templates: templatesReducer,
    mcValidation: mcValidationReducer,
    realParams: realParamsReducer,
    sms: smsReducer,
    interstitialFormData: interstitialFormDataReducer,
    interstitial: interstitialReducer,
    nativePushFormData: nativePushFormDataReducer,
    nativePush: nativePushReducer,
    cbSelectedTemplate: cbSelectedTemplateReducer,
  },
});
export type StoreDispatch = typeof store.dispatch;
export type StoreState = ReturnType<typeof store.getState>;
